import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Wallet.svg?component
var Wallet_exports = /* @__PURE__ */ __exportAll({
	default: () => Wallet_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M2.97 2.771 13.908 5.88a3.77 3.77 0 0 1 2.592 3.5v10.51a2.052 2.052 0 0 1-2.6 2.167l-9.048-2.46a3.7 3.7 0 0 1-2.6-3.457V4.688a2.75 2.75 0 0 1 2.67-2.813H18.75a3 3 0 0 1 3 3v8.953a3.073 3.073 0 0 1-3.11 3.047H16.5" }, null, -1), createElementVNode("path", { d: "M12.375 13.875a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m9.375-3.75H16.5" }, null, -1)])]);
}
var Wallet_default = { render: render$1 };
//#endregion
export { Wallet_exports, Wallet_default as default, render$1 as render };

//# sourceMappingURL=Wallet.svg.virtual.js.map